var alignment_rtlignore_default = {
  "alignLeft": "aBNOx",
  "textWrapNowrap": "QtyLu",
  "alignRight": "_48x28",
  "alignCenter": "iOJNS",
  "sizeFullWidth": "PbyL3",
  "renderedInTable": "h0zKV",
  "sizeOriginal": "mPhn6",
  "sizeContent": "aHJUb",
  "sizeSmall": "kqt7o",
  "sizeSmallCenter": "sgIl4",
  "flex": "_5ybA3",
  "LEFT": "uXelx",
  "CENTER": "RAcG-",
  "RIGHT": "LQ-mq",
  "AUTO": "WGebp",
  "JUSTIFY": "ucmSL"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
